

















































































import {Component, Prop, Vue, Emit} from 'nuxt-property-decorator'
import {Loading} from '../Loading'
import {debounce} from 'debounce'

@Component({
  components: {
    Loading,
  },
})
class FormSelect extends Vue {
  name = 'form-select'

  /**
   * Options for the dropdown
   */
  @Prop({type: Array, default: () => []})
  options!: any[]

  /**
   * Error message
   */
  @Prop({type: String, default: undefined})
  errorMessage!: string | undefined

  /**
   * Options for the dropdown
   */
  @Prop({type: Boolean, default: false})
  searchable!: boolean

  /**
   * Minimal style
   */
  @Prop({type: Boolean, default: false})
  minimal!: boolean

  /**
   * Do the options change async?
   */
  @Prop({type: Boolean, default: false})
  async!: boolean

  /**
   * v-model setup
   */
  @Prop({type: Object, required: false, default: null})
  value!: any

  /**
   * Are the options in a loading state?
   */
  @Prop({type: Boolean, default: false})
  loading!: boolean

  /**
   * Placeholder text
   */
  @Prop({type: String, default: 'Select an option'})
  placeholder!: string

  /**
   * Label text
   */
  @Prop({type: String, default: ''})
  label!: string

  /**
   * Which property are we using to display the current value in text form
   */
  @Prop({type: String, default: 'name'})
  displayProperty!: string

  /**
   * Use a function to determine display value
   */
  @Prop({type: Function, default: null, required: false})
  displayValue!: (option: any) => string | null

  /**
   * Which property are we using to detect the current value (unique ID)
   */
  @Prop({type: String, default: 'id'})
  valueProperty!: string

  @Prop({type: String, default: () => ''})
  optionClass!: string

  @Prop({type: Boolean, default: true})
  showCloseIcon!: boolean

  txt: null | string = null
  // searchText: string = (this.value && this.value[this.displayProperty]) ? this.value[this.displayProperty] : ''
  originalSearchText =
    this.value && this.getDisplayValue(this.value)
  focused: boolean = false
  hoverIndex: number = 0
  closeTimeout?: NodeJS.Timeout

  get filteredOptions() {
    return this.options.filter(({disabled = false}) => !disabled)
  }

  get searchText() {
    return this.txt === null
      ? this.getDisplayValue(this.value)
      : this.txt
  }

  set searchText(value: string | null) {
    this.txt = value
  }

  get currentOptions() {
    if (
      this.async === false &&
      this.searchable &&
      this.searchText != this.originalSearchText
    ) {
      return this.filteredOptions.filter(
        (o) =>
          this.getDisplayValue(o)
            .toLowerCase()
            .indexOf((this.searchText || '').toLowerCase()) !== -1
      )
    }

    return this.filteredOptions
  }

  get open() {
    // ((this.searchable && !!this.searchText) || !this.searchable) &&
    return this.focused
  }

  get inputElement(): HTMLElement {
    return this.$refs.input as HTMLElement
  }

  getDisplayValue (option: any) {
    if (!option) {
      return ''
    }

    if (this.displayValue && typeof this.displayValue === 'function') {
      try {
        return this.displayValue(option)
      } catch (e) {
        console.error(e)
        return ''
      }
    }

    try {
      return option[this.displayProperty] || ''
    } catch (e) {
      console.error(e)
      return ''
    }
  }

  /**
   * Value changed, updates v-model
   */
  @Emit('input')
  setOption(option) {
    return option
  }

  select(option: any) {
    this.setOption(option)
    this.onSelect()
  }

  onSelect() {
    this.$nextTick(() => {
      this.inputElement.blur()
      this.searchText = null
      this.focused = false
    })
  }

  selectHovered() {
    if (this.currentOptions.length > 0) {
      this.setOption(this.currentOptions[this.hoverIndex])
      this.onSelect()
    }
  }

  @Emit('clear')
  clearText() {
    this.inputElement.focus()
    this.focused = true
    this.txt = ''

    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout)
    }
  }

  removeSelection() {
    this.setOption(null)
    this.clearText()
  }

  blur() {
    this.closeTimeout = setTimeout(() => {
      this.focused = false
      this.searchText = null
      this.originalSearchText = this.searchText
    }, 250)
  }

  moveUp() {
    if (--this.hoverIndex < 0) {
      this.hoverIndex = this.currentOptions.length - 1
    }
  }

  moveDown() {
    if (++this.hoverIndex >= this.currentOptions.length) {
      this.hoverIndex = 0
    }
  }

  searchChanged = debounce(function (this: FormSelect) {
    /**
     * Search text input changed. You should update the options here
     */
    this.$emit('changed', this.searchText)
  }, 300)

  input() {
    this.hoverIndex = 0
    this.originalSearchText = null
    this.searchChanged()
  }
}

export default FormSelect
